import AppHeader from "../../layout/AppHeader";
import Customer from '../../xpost/views/register/customer/Customer.vue';
import CustomerAdd from '../../xpost/views/register/customer/CustomerAdd.vue';
import CustomerMy from '../../xpost/views/register/customer/CustomerMy.vue';
import CustomerTransfer from '../../xpost/views/register/customer/CustomerTransfer.vue';

const CustomerRoutes = [
    {
        path: "/cadastro/cliente",
        name: "customer",
        components: {
            header: AppHeader,
            default: Customer,
        }
    },
    {
        path: "/cadastro/cliente/meu",
        name: "customer.my",
        components: {
            header: AppHeader,
            default: CustomerMy,
        }
    },
    {
        path: "/cadastro/cliente/adicionar",
        name: "customer.add",
        components: {
            header: AppHeader,
            default: CustomerAdd,
        }
    },
    {
        path: "/cadastro/cliente/transferir",
        name: "customer.transfer",
        components: {
            header: AppHeader,
            default: CustomerTransfer,
        }
    },
    {
        path: '/cadastro/cliente/adicionar/:id',
        name: 'customer.edit',
        components: {
            header: AppHeader,
            default: CustomerAdd,
        }
    }
]

export default CustomerRoutes;